/**
 * 农行云闪付收银台。进页就出链，支付链接画成二维码后再收起加载。
 * 电脑只展示二维码。手机同时给出保存图片和立即支付，立即支付跳已有链接。
 */
import { executeNhBankPay, fetchNhBankCashierPage } from '@/api/api'
import { buildQrImageSrc } from '@/utils/qrRender'

export function isDesktopBrowser () {
  if (typeof navigator === 'undefined') return false
  const ua = (navigator.userAgent || '').toLowerCase()
  return !/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile/i.test(ua)
}

export function pickPayUrl (payload) {
  if (!payload) return ''
  const pay = String(payload.payUrl || payload.channelPayUrl || payload.codeUrl || '').trim()
  return /^https?:\/\//i.test(pay) ? pay : ''
}

export async function loadPageContext (orderId, token) {
  const ctx = await fetchNhBankCashierPage(orderId, token)
  if (!ctx) throw new Error('页面加载失败')
  return ctx
}

export async function requestExecute (orderId, token) {
  try {
    const d = await executeNhBankPay(orderId, token)
    if (!d) throw new Error('网络异常')
    return d
  } catch (err) {
    const vo = err && err.data
    if (vo && vo.message) throw new Error(vo.message)
    const msg = (err && err.message) || ''
    if (err && (err.code === 'ECONNABORTED' || /timeout/i.test(msg))) {
      throw new Error('支付请求超时，请稍后重试')
    }
    throw new Error(msg || '出链失败，请重试')
  }
}

export function formatCountdown (leftMs) {
  const s = Math.max(0, Math.floor(leftMs / 1000))
  const h = String(Math.floor(s / 3600)).padStart(2, '0')
  const m = String(Math.floor((s % 3600) / 60)).padStart(2, '0')
  const sec = String(s % 60).padStart(2, '0')
  return h + ':' + m + ':' + sec
}

function nhBankQrPixelSize () {
  const vw = typeof window !== 'undefined' ? window.innerWidth : 390
  return Math.max(300, Math.min(360, Math.floor(vw * 0.86)))
}

export async function renderQrToElement (el, text) {
  if (!el || !text) return false
  const size = nhBankQrPixelSize()
  const src = await buildQrImageSrc(text, {
    pixelSize: size,
    errorCorrectionLevel: 'L',
    margin: 4
  })
  if (!src) return false
  el.innerHTML = ''
  const img = document.createElement('img')
  img.src = src
  img.width = size
  img.height = size
  img.alt = '云闪付二维码'
  img.style.maxWidth = '100%'
  img.style.height = 'auto'
  el.appendChild(img)
  return true
}
